import React from 'react';
interface HeaderProps {
  progress: number;
  label: string;
}
export function Header({
  progress,
  label
}: HeaderProps) {
  return <header className="bg-white w-full sticky top-0 z-10 border-b border-rose-100/80" data-id="element-33">
      <div className="flex flex-col items-center justify-center pt-3 pb-2.5 px-5" data-id="element-34">
        <div className="flex items-center gap-1.5 mb-2" data-id="element-35">
          <span className="text-base" data-id="element-36">🍩</span>
          <h1 className="text-[10px] font-extrabold tracking-[0.22em] uppercase text-rose-700 leading-none" data-id="element-37">
            RecursoHub · Quiz Minidonas
          </h1>
        </div>

        <div className="w-full max-w-sm" data-id="element-38">
          <div className="h-2 w-full bg-rose-100 rounded-full overflow-hidden" data-id="element-39">
            <div className="h-full bg-gradient-to-r from-rose-500 via-pink-500 to-amber-400 transition-all duration-500 ease-out rounded-full relative" style={{
            width: `${progress}%`
          }} data-id="element-40">
              <div className="absolute inset-0 bg-white/25 animate-pulse" data-id="element-41" />
            </div>
          </div>
          <div className="flex items-center justify-between mt-1.5" data-id="element-42">
            <span className="text-[10px] font-bold text-rose-900 uppercase tracking-wide" data-id="element-43">
              {label}
            </span>
            <span className="text-[10px] font-extrabold text-rose-600 tabular-nums" data-id="element-44">
              {progress}%
            </span>
          </div>
        </div>
      </div>
    </header>;
}